/**
 * PublicScheduleAPI.js
 * Funções sem autenticação para as rotas públicas de agendamento.
 */

const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://www.gabriela.app.br/api/';
const PUBLIC_SCHEDULE_BASE = BASE_URL + 'public/schedule/';

/**
 * Busca dados públicos da empresa pelo slug.
 * @param {string} companySlug
 * @param {function} callback - ({ success, company }) ou ({ success: false, error })
 */
export const GetPublicCompanyAPI = (companySlug, callback) => {
    const url = PUBLIC_SCHEDULE_BASE + 'get_company.php';
    const body = 'company_slug=' + encodeURIComponent(companySlug);

    fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body,
    })
        .then(res => res.json())
        .then(data => callback(data))
        .catch(() => callback({ success: false, error: 'Erro de conexão.' }));
};

/**
 * Busca slots disponíveis para um profissional em um RANGE de datas (ex: mês inteiro).
 * Retorna um mapa { "YYYY-MM-DD": { hasAvailability, availableCount, slots } }.
 * @param {string} companySlug
 * @param {string|number} professionalId
 * @param {string} startDate - YYYY-MM-DD
 * @param {string} endDate - YYYY-MM-DD
 * @param {function} callback - ({ success, dates: { ... } })
 * @param {number} [procedureDuration] - duração do procedimento em minutos (opcional)
 */
export const GetPublicAvailableSlotsRangeAPI = (companySlug, professionalId, startDate, endDate, callback, procedureDuration) => {
    const url = PUBLIC_SCHEDULE_BASE + 'get_available_slots_range.php';
    let body =
        'company_slug=' + encodeURIComponent(companySlug) +
        '&professional_id=' + professionalId +
        '&start_date=' + encodeURIComponent(startDate) +
        '&end_date=' + encodeURIComponent(endDate);

    if (procedureDuration && procedureDuration > 0) {
        body += '&procedure_duration=' + parseInt(procedureDuration, 10);
    }

    fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body,
    })
        .then(res => res.json())
        .then(data => callback(data))
        .catch(() => callback({ success: false, error: 'Erro de conexão.' }));
};

/**
 * Busca slots disponíveis para um profissional em uma data.
 * @param {string} companySlug
 * @param {string|number} professionalId
 * @param {string} date - YYYY-MM-DD
 * @param {function} callback - ({ success, date, professional_id, slots: [{time, available}] })
 * @param {number} [procedureDuration] - duração do procedimento em minutos (opcional)
 */
export const GetPublicAvailableSlotsAPI = (companySlug, professionalId, date, callback, procedureDuration) => {
    const url = PUBLIC_SCHEDULE_BASE + 'get_available_slots.php';
    let body =
        'company_slug=' + encodeURIComponent(companySlug) +
        '&professional_id=' + professionalId +
        '&date=' + encodeURIComponent(date);

    if (procedureDuration && procedureDuration > 0) {
        body += '&procedure_duration=' + parseInt(procedureDuration, 10);
    }

    fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body,
    })
        .then(res => res.json())
        .then(data => callback(data))
        .catch(() => callback({ success: false, error: 'Erro de conexão.' }));
};
